/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import RelatedFile from './RelatedFile';

class RelatedFiles extends React.Component {
  constructor(props) {
    super(props);
    this.files = props.files.map((f, i) => {
      return <RelatedFile key={i} id={f.get('id')} title={f.get('title')} />;
    });
  }

  render() {
    return this.files.length > 0 ? (
      <span>
        <h3>{FW.store.get('site').prop('related_files_title') ? FW.store.get('site').prop('related_files_title') : 'Related Files'}</h3>
        <div className="related-files" style={{fontSize: 18}}>{this.files}</div>
      </span>
    ) : null;
  }
}

export default RelatedFiles;
